import React from 'react';
import twMerge from 'utilities/src/twMerge';

type TagSize = 'small' | 'medium';

interface TagProps {
  label: string;
  url: string;
  size?: TagSize;
  className?: string;
}

export default function Tag({ label, url, size = 'small', className }: TagProps) {
  const baseClasses =
    'text-site-neutrals-700 bg-site-neutrals-0 border-site-neutrals-100 hover:border-site-primary-600 rounded-lg border px-3 hover:shadow-lv3';
  const sizeClasses = size === 'medium' ? 'site-paragraph-s py-2' : 'site-paragraph-xs py-1';

  return (
    <a href={url}>
      <span className={twMerge(baseClasses, sizeClasses, className)}>{label}</span>
    </a>
  );
}
